export default __webpack_public_path__ + "static/media/content3.a3c904ff.png";